import React, { useState, useRef, useEffect } from "react";
import {
  SettingsContainer,
  LogoutContainer
} from "../styled_components/containers";
import { navigate } from "@reach/router";
import useAuth from "../../auth/hooks/useAuth";
import settings_icon from "../assets/settings.png";
import Logout from "../styled_components/log-out";

function Settings() {
  const [clicked, setClicked] = useState(false);
  const menuItem = useRef();
  const logoutContainer = useRef();
  const { dispatch } = useAuth();

  const handleClick = e => {
    if (menuItem.current.contains(e.target)) {
      return;
    }

    if (logoutContainer.current.contains(e.target)) {
      return;
    }

    setClicked(false);
  };

  const logout = () => {
    localStorage.removeItem("app_token");
    dispatch({
      type: "remove_token"
    });
    navigate("/");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return (
    <SettingsContainer>
      <img
        ref={menuItem}
        src={settings_icon}
        alt="settings-icon"
        onClick={() => setClicked(!clicked)}
      />
      <LogoutContainer ref={logoutContainer} open={clicked}>
        <Logout onClick={() => logout()}>Logout</Logout>
      </LogoutContainer>
    </SettingsContainer>
  );
}

export default Settings;
